<div class="card card-step" [ngClass]="{ 'is-selected': selectedValueControl.value === entity.id, 'is-desktop': isDesktop }">
  <div class="card-header">
    <app-radio-button
      [control]="selectedValueControl"
      [id]="entity.id"
      [label]="label"
      [value]="entity.id"
      [classGroup]="'not-mb'"
    ></app-radio-button>
  </div>
  <div class="card-body card-body-info" *ngIf="selectedValueControl.value === entity.id && !isDesktop">
    <app-card-step-body [isShowIdentifierBlock]="isShowIdentifierBlock" [entity]="entity"></app-card-step-body>
  </div>
  <div class="card-footer card-footer-info" *ngIf="code === enumEntityModelCode.IMPORTER && !isDesktop">
    <button class="btn btn-link" (click)="onEditUP()">
      <i class="fa fa-pencil"></i>
      {{ "EDIT_COMPANY" | translate }}
    </button>
  </div>
</div>
